module.exports = __webpack_public_path__ + "static/media/ssb.adb5c511.png";